import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { createIdentityProvider, updateIdentityProvider } from './form.thunks';

export interface IdentityProviderFormState {
  loading: boolean;
  error: string | null;
}

export const initialState: IdentityProviderFormState = {
  error: null,
  loading: false
};

const getIdentityProviderForm = (state: RootState): IdentityProviderFormState => state.identityProviders.form;
const getLoading = (state: RootState): boolean => getIdentityProviderForm(state).loading;
const getError = (state: RootState): string | null => getIdentityProviderForm(state).error;

export const selectors = {
  getIdentityProviderForm,
  getLoading,
  getError
};

export const extraReducers = {
  [createIdentityProvider.pending.type]: (state: IdentityProviderFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [createIdentityProvider.fulfilled.type]: (state: IdentityProviderFormState): void => {
    state.loading = false;
  },
  [createIdentityProvider.rejected.type]: (state: IdentityProviderFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  },
  [updateIdentityProvider.pending.type]: (state: IdentityProviderFormState): void => {
    state.loading = true;
    state.error = null;
  },
  [updateIdentityProvider.fulfilled.type]: (state: IdentityProviderFormState): void => {
    state.loading = false;
  },
  [updateIdentityProvider.rejected.type]: (state: IdentityProviderFormState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
  }
};

const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    clearForm: (state: IdentityProviderFormState): void => {
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers
});

export default formSlice.reducer;

export const actions = formSlice.actions;
